import React, { useState } from 'react';
import { Navbar, Nav, Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Header.css"; // Import custom CSS
import { Layout, Menu, Space, Typography } from 'antd';
import {  Outlet, useLocation } from 'react-router-dom';
import logo from "../assets/images/anm.svg";
import { Image } from 'react-bootstrap';
import {
  HomeOutlined, BarChartOutlined, GlobalOutlined, SettingOutlined, TeamOutlined,
  CloudServerOutlined, ContainerOutlined, HddOutlined, ToolOutlined, KeyOutlined,
  ClusterOutlined, UserOutlined, DollarCircleOutlined, SaveOutlined, UserAddOutlined,
  FileTextOutlined, LockOutlined, QuestionCircleOutlined, InboxOutlined, CloudOutlined,
} from '@ant-design/icons';

const { Header, Sider, Content } = Layout;
const { Text, Title } = Typography;

const items = [
  { key: '/dashboard', icon: <HomeOutlined />, label: 'Dashboard' },
  { key: '/explore', icon: <BarChartOutlined />, label: 'Explore' },
  { key: '/domain', icon: <GlobalOutlined />, label: 'Domain' },
  { key: '/servers', icon: <CloudServerOutlined />, label: 'Servers' },

  {
    key: 'manage',
    icon: <SettingOutlined />,
    label: 'Manage',
    children: [
      { key: '/pods', icon: <CloudServerOutlined />, label: 'Pods' },
      { key: '/serverless', icon: <ContainerOutlined />, label: 'Serverless' },
      { key: '/storage', icon: <HddOutlined />, label: 'Storage' },
      { key: '/tuning', icon: <ToolOutlined />, label: 'Fine Tuning' },
      { key: '/secrets', icon: <KeyOutlined />, label: 'Secrets' },
      { key: '/cluster', icon: <ClusterOutlined />, label: 'Instant Cluster' },
      { key: '/bare-metal', icon: <ToolOutlined />, label: 'Bare Metal' },
    ],
  },

  {
    key: 'account',
    icon: <TeamOutlined />,
    label: 'Account',
    children: [
      { key: '/settings', icon: <UserOutlined />, label: 'Settings' },
      { key: '/billing', icon: <DollarCircleOutlined />, label: 'Billing' },
      { key: '/plans', icon: <SaveOutlined />, label: 'Saving Plans' },
      { key: '/team', icon: <UserAddOutlined />, label: 'Team' },
      { key: '/logs', icon: <FileTextOutlined />, label: 'Audit Logs' },
      { key: '/access', icon: <LockOutlined />, label: 'Remote Access' },
    ],
  },

  {
    key: 'storage',
    icon: <InboxOutlined />,
    label: 'Storage',
    children: [
      { key: '/object-storage', icon: <CloudOutlined />, label: 'Object Storage' },
      { key: '/storage-boxes', icon: <InboxOutlined />, label: 'Storage Boxes' },
    ],
  },

  { key: '/help', icon: <QuestionCircleOutlined />, label: 'Help' },
];

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const hideHeader =
    location.pathname.startsWith('/addservers') ||
    location.pathname.startsWith('/servers');

  return (
    <Layout style={{ minHeight: '100vh' }}>
      
      {/* LEFT SIDEBAR */}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        width={250}
         breakpoint="lg"
        collapsedWidth="0"
  
        style={{ background: '#fff',
           position: 'sticky',
           top: 0,
            zIndex: 1000,   
           height: '100vh',
         }}
       
  
      >
        <div
          style={{
            height: 64,
            margin: 16,
            color: '#1e2a53',
            display: 'flex',
            // justifyContent: 'center',
            alignItems: 'center',
            fontSize: 20,
            fontWeight: 'bold',
          }}
        >
          <Image src={logo} alt="ANM Logo" height="30" />
          <span style={{ marginLeft: 8 }}>ANM Console</span>
        </div>

        <Menu
          mode="inline"
          theme="light"
          selectedKeys={[location.pathname]}
          style={{ background: '#fff' }}
          items={items.map((item) => ({
            key: item.key,
            icon: item.icon,
            label: item.children
              ? item.label
              : <Link to={item.key}>{item.label}</Link>,
            children: item.children?.map((child) => ({
              key: child.key,
              icon: child.icon,
              label: <Link to={child.key}>{child.label}</Link>,
            })),
          }))}
        />
      </Sider>

      {/* CENTER CONTENT */}
      <Layout>
        {!hideHeader && (
          <Header
            style={{
             
              background: '#fff',
              padding: '0 24px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              position: 'sticky',
              top: 0,
              zIndex: 1000,
            }}
          >

            <Title level={4} style={{ margin: 0 }}>Dashboard</Title>
            <Space size="middle" wrap>
              <Text>Docs</Text>
              <Text>Referrals</Text>
              <Text>$0.00</Text>
            </Space> 
           
          </Header>
        )}

        <Content style={{ padding: '16px',
    minHeight: '100vh', }}>
          <Outlet />
        </Content>
      </Layout>

      {/* INLINE MENU STYLING */}
      <style>{`
       @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

        .ant-menu-light .ant-menu-item {
          font-family: 'Poppins', sans-serif !important;
          font-size: 16px;
          color: #4f57f6;
          border-radius: 10px;
          margin: 12px 10px;
          transition: 0.2s;
        }

       .ant-menu-submenu-title{
       font-family: 'Poppins', sans-serif !important;
          font-size: 16px;
           color: #4f57f6 !important;
          border-radius: 10px;
          margin: 12px 10px;
          transition: 0.2s;
       }
          /* 🔥 REMOVE TEXT-DECORATION FROM ALL LINKS */
 .ant-menu-light .ant-menu-item a,
 .ant-menu-light .ant-menu-submenu a {
    text-decoration: none !important;
 }
    /* Collapse Footer Icon */
.ant-layout-sider-trigger {
  background-color: #4f57f6 !important;
  color: #fff !important;       /* icon color */
  font-size: 18px !important;
}
  /* MOBILE */
@media (max-width: 768px) {
  .ant-layout-header {
    padding: 0 12px !important;
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    font-size: 14px !important;
    margin: 8px 6px !important;
  }
}

/* FOLDABLES */
@media (max-width: 600px) {
  .ant-layout-content {
    padding: 12px !important;
  }
}


      `}</style>

    </Layout>
  );
};

export default MainLayout;
